<template>
    <v-container class="grey-lighten-3 full-height">

        <!-- Printable Area -->
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <v-sheet class="report-paper pa-5 mx-auto" elevation="3" id="printable-area">

                    <!-- Header Section (Will repeat on each page) -->
                    <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start lines">
                            <div class="company-info">
                                <h4 class="company-name text-uppercase font-weight-bold mb-1">
                                    {{ purchaseOrderData?.branch?.company?.name || 'Company Name Not Available' }}
                                </h4>
                                <p class="company-text mb-1" style="width:65%">{{
                                    purchaseOrderData?.branch?.company?.address || '-' }}</p>
                                <p class="company-text mb-1">
                                    <v-icon size="small" class="mr-1">mdi-phone-outline</v-icon>
                                    {{ purchaseOrderData?.branch?.company?.mobile || '-' }}
                                </p>
                                <p class="company-text mb-1">
                                    <v-icon size="small" class="mr-1">mdi-email-outline</v-icon>
                                    {{ purchaseOrderData?.branch?.company?.email || '-' }}
                                </p>
                                <p class="company-text" v-if="purchaseOrderData?.branch?.company?.website">
                                    <v-icon size="small" class="mr-1">mdi-web</v-icon>
                                    {{ purchaseOrderData?.branch?.company?.website }}
                                </p>
                            </div>

                            <div class="logo-container">
                                <v-img
                                    :src="`${getFileServerUrl.replace(/\/$/, '')}/${purchaseOrderData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                                    max-width="150" max-height="70" class="logo-img" contain />
                            </div>
                        </div>

                        <!-- Title -->
                        <div class="text-center my-6">
                            <h2 class="report-title font-weight-bold">
                                PURCHASE ORDER INVOICE
                            </h2>
                           
                        </div>
                        
                    </div>

                    <!-- Main Content -->
                    <div class="page-content">
                        <!-- Master Information -->
                        <div class="meta-info-box mb-0">
                            <div class="d-flex">
                                <div class="meta-item d-flex align-center"
                                    style="width: 50%;">
                                    <span class="meta-label">Purchase Order No:</span>
                                    <span class="meta-value pl-2 font-weight-bold">{{ purchaseOrderData?.code }}</span>
                                </div>
                                <div class="meta-item d-flex align-center justify-end"
                                    style="width: 50%;">
                                    <span class="meta-label pl-2"> Date:</span>
                                    <span class="meta-value pl-2">{{ formatDateTime(purchaseOrderData?.purchase_date)
                                        }}</span>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div style="width: 100%; height: auto; min-height: auto;">
                                    <div style="margin-bottom: 8px;">
                                        <strong>To,</strong>
                                    </div>
                                    <div style="margin-bottom: 4px; font-weight: bold;">
                                        {{ purchaseOrderData?.supplier?.supplier_name || '-' }}
                                    </div>
                                    <div style="margin-bottom: 16px;">
                                        {{ purchaseOrderData?.supplier?.supplier_address || '-' }}
                                    </div>
                                    <div style="margin-bottom: 4px;" v-if="purchaseOrderData?.subject">
                                        <strong>Subject: {{ purchaseOrderData.subject }}</strong>
                                    </div>
                                    <div style="margin-bottom: 4px;" v-else>
                                        <strong>Subject: Purchase Order for {{ purchaseOrderData?.code }}</strong>
                                    </div>
                                    <div style="margin-bottom: 4px;">
                                        Dear Sir,
                                    </div>
                                    <div style="margin-bottom: 0;">
                                        We are pleased to place work order with the following item as per terms and condition.
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="d-flex">
                                <div class="meta-item d-flex align-center"
                                    style="width: 50%;">
                                    <span class="meta-label pl-2">Warehouse: </span>
                                    <span class="meta-value pl-2">{{ purchaseOrderData?.warehouse?.name }}</span>
                                </div>
                            </div> -->
                            
                        </div>

                        <!-- Purchase Requisition Details Table -->
                        <div class="table-container mb-6 mt-0">
                            <table class="dep-table">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 40px;">SL</th>
                                        <th>Product Name</th>
                                        <th>Product Code</th>
                                        <th>Unit</th>
                                        <th>Quantity</th>
                                        <th>Price</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(detail, index) in purchaseOrderData?.pur_order_details"
                                        :key="detail.id">
                                        <td class="text-center">{{ index + 1 }}</td>
                                        <td class="text-center">{{ detail.product?.name }}</td>
                                        <td class="text-center">{{ detail.product?.code }}</td>
                                        <td class="text-center">{{ detail.product?.unit?.name }}</td>
                                        <td class="text-right">{{ detail?.qty }}</td>
                                        <td class="text-right">{{ detail?.rate }}</td>
                                        <td class="text-right">{{ detail?.qty * detail?.rate }}</td>
                                    </tr>
                                    <tr>
                                        <td style="border-right: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right" style="border-right: none ; border-left: none ;">Subtotal
                                        </td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right">{{ purchaseOrderData?.sub_total }}</td>
                                    </tr>
                                    <tr>
                                        <td style="border-right: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right" style="border-right: none ; border-left: none ;">Discount
                                        </td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right">{{ purchaseOrderData?.discount_amount }}</td>
                                    </tr>
                                    <tr>
                                        <td style="border-right: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right" style="border-right: none ; border-left: none ;">Tax ({{
                                            purchaseOrderData?.tax_type === "1"? "Included": "Excluded" }})</td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right">{{ purchaseOrderData?.tax_amount }}</td>
                                    </tr>
                                    <tr>
                                        <td style="border-right: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right" style="border-right: none ; border-left: none ;">Vat ({{
                                            purchaseOrderData?.vat_type === "1"? "Included": "Excluded" }})</td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right">{{ purchaseOrderData?.vat_amount }}</td>
                                    </tr>
                                    <tr>
                                        <td style="border-right: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right" style="border-right: none ; border-left: none ;">Grand
                                            Total </td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td style="border-right: none ; border-left: none ;"></td>
                                        <td class="text-right">{{ purchaseOrderData?.grand_total }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Grand Total in Words -->
                        <div class="amount-in-words-section mb-4" v-if="purchaseOrderData?.grand_total">
                            <div class="font-weight-bold" style="font-size: 14px; color: #333;">
                                Amount in Words: <span style="font-weight: normal; text-transform: capitalize;">{{ getGrandTotalInWords() }}</span>
                            </div>
                        </div>

                        <!-- Terms and Conditions Section -->
                        <div class="terms-section mb-4" v-if="purchaseOrderData?.terms_and_condition">
                            <div class="font-weight-bold mb-2" style="font-size: 14px; color: #333;">
                                Terms and Conditions:
                            </div>
                            <div class="terms-content" style="font-size: 14px; color: #555; line-height: 1.6; white-space: pre-wrap;">
                                {{ purchaseOrderData.terms_and_condition }}
                            </div>
                        </div>

                        <!-- Prepared By Info -->
                        <div class="d-flex mb-4" style="justify-content: space-between;">
                            <div class="prepared-section" style="width: 50%;">
                                <div class="font-weight-bold mb-1">Prepared By:</div>
                                <div>{{ purchaseOrderData?.created_by?.full_name || '-' }}</div>
                                <div v-if="purchaseOrderData?.created_by?.branch?.company?.name">
                                    {{ purchaseOrderData?.created_by?.branch?.company?.name }}
                                </div>
                            </div>
                            <div class="prepared-section" style="width: 30%; ">
                                <div class="font-weight-bold mb-1 pr-2">Approved By:</div>
                                <div class="pr-2">{{ purchaseOrderData?.created_by?.full_name || '-' }}</div>
                                <div class="pr-2" v-if="purchaseOrderData?.created_by?.branch?.company?.name">
                                    {{ purchaseOrderData?.created_by?.branch?.company?.name }}
                                </div>
                            </div>
                        </div>

                        <!-- Signature Section -->

                        <!-- <div class="signature-section" style="margin-top: auto; padding-top: 100px;">
                            <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                                <div>
                                    <p
                                        style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center; padding-top: 5px;">
                                        <span>Receiver's Signature</span>
                                    </p>
                                </div>
                                <div>
                                    <p
                                        style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center; padding-top: 5px;">
                                        <span>Remex Ingredient Solution</span>
                                    </p>
                                </div>
                            </div>
                        </div> -->

                        <!-- System Generated Footer -->
                        <div class="system-generated-footer" style="text-align: center; margin-top: 20px; padding-top: 10px; font-size: 12px; color: #666; border-top: 1px solid #ddd;">
                            System generated 
                        </div>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>

        <!-- Action Toolbar (Hidden on Print) -->
        <v-row class="d-print-none mb-4" justify="center">
            <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
                <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                    Download PDF
                </v-btn>

                <v-btn color="primary" prepend-icon="mdi-printer" @click="printPage">
                    Print
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";
import convertNumberToWords from "@/plugins/numberToWord";

export default {
    name: "Sales",

    data: () => ({
        mainId: null,
        purchaseOrderData: null,
    }),

    watch: {},

    created() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.$store.dispatch("getPurOrderById", id).then((response) => {
            console.log('Purchase Order Data:', response);
            console.log('Branch:', response?.branch);
            console.log('Company:', response?.branch?.company);
            console.log('Created By:', response?.created_by);
            console.log('Created By Branch Company:', response?.created_by?.branch?.company);
            this.purchaseOrderData = response;
        });
    },

    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
    },

    methods: {
        formatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
                .toString()
                .padStart(2, "0")}/${d.getFullYear()}`;
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const d = new Date(dateTime);
            return `${this.formatDate(dateTime)} ${d.toLocaleTimeString()}`;
        },
        formatNumber(num) {
            return num ? Number(num).toFixed(2) : "0.00";
        },
        getGrandTotalInWords() {
            if (!this.purchaseOrderData?.grand_total) {
                return "Zero Taka Only";
            }
            try {
                return convertNumberToWords(this.purchaseOrderData.grand_total);
            } catch (error) {
                console.error('Error converting number to words:', error);
                return "Zero Taka Only";
            }
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `purchase-order-${this.purchaseOrderData?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { 
                    scale: 2, 
                    useCORS: true,
                    backgroundColor: '#ffffff',
                    logging: false,
                    letterRendering: true
                },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
        printPage() {
            const element = document.getElementById("printable-area");

            // Clone the element to preserve structure
            const clonedElement = element.cloneNode(true);

            // Convert Vuetify classes to inline styles or CSS
            const printContent = clonedElement.outerHTML;

            const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Purchase Order Invoice</title>
                    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: 'Times New Roman', serif;
                        background: white;
                        margin: 0;
                        padding: 0;
                    }
                    .report-paper {
                        background-color: white;
                        color: black;
                        font-family: 'Times New Roman', serif;
                        max-width: 280mm;
                        width: 100%;
                        margin: 0 auto;
                        padding: 20px;
                        min-height: 297mm;
                        box-shadow: none !important;
                        display: block;
                    }
                    .page-header {
                        margin-bottom: 20px;
                    }
                    .page-content {
                        display: block;
                    }
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        border-bottom: 2px solid #eee;
                        padding-bottom: 10px;
                        margin-top: 16px;
                        margin-bottom: 16px;
                    }
                    .company-info {
                        flex: 1;
                    }
                    .company-name {
                        color: #333;
                        font-size: 20px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin: 0 0 4px 0;
                        letter-spacing: 0.5px;
                    }
                    .company-text {
                        font-size: 14px;
                        color: #555;
                        margin: 2px 0;
                        display: flex;
                        align-items: center;
                    }
                    .logo-container {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }
                    .logo-img, .logo-container img {
                        max-height: 70px;
                        max-width: 150px;
                        object-fit: contain;
                    }
                    .report-title {
                        color: #333;
                        font-size: 20px;
                        font-weight: bold;
                        text-align: center;
                        margin: 16px 0;
                        text-decoration: underline;
                        text-underline-offset: 4px;
                    }
                    .meta-info-box {
                        border: none;
                        margin-bottom: 16px;
                    }
                    .meta-item {
                        height: auto;
                        display: flex;
                        align-items: center;
                    }
                    .meta-item:not(.justify-end) {
                        justify-content: flex-start !important;
                        text-align: left !important;
                    }
                    .meta-label {
                        font-weight: 500;
                        color: #333;
                        padding-left: 0;
                        text-align: left !important;
                    }
                    .meta-value {
                        padding-left: 8px;
                        color: #555;
                    }
                    .d-flex {
                        display: flex;
                    }
                    .justify-space-between {
                        justify-content: space-between;
                    }
                    .justify-end {
                        justify-content: flex-end !important;
                    }
                    .align-end {
                        align-items: flex-end;
                    }
                    .align-start {
                        align-items: flex-start;
                    }
                    .align-center {
                        align-items: center;
                    }
                    .text-center {
                        text-align: center;
                    }
                    .text-right {
                        text-align: right;
                    }
                    .text-uppercase {
                        text-transform: uppercase;
                    }
                    .font-weight-bold {
                        font-weight: bold;
                    }
                    .mb-1 {
                        margin-bottom: 4px;
                    }
                    .mb-4 {
                        margin-bottom: 16px;
                    }
                    .mb-6 {
                        margin-bottom: 24px;
                    }
                    .mb-8 {
                        margin-bottom: 32px;
                    }
                    .my-6 {
                        margin-top: 24px;
                        margin-bottom: 24px;
                    }
                    .pl-2 {
                        padding-left: 8px;
                    }
                    .mr-1 {
                        margin-right: 4px;
                    }
                    .lines {
                        border-bottom: 2px solid #eee;
                        padding-bottom: 10px;
                    }
                    .table-container {
                        margin-bottom: 24px;
                    }
                    .dep-table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 14px;
                        margin-bottom: 24px;
                    }
                    .dep-table th {
                        background-color: #f0f0f0;
                        border: 1px solid #000;
                        padding: 8px 5px;
                        color: #333;
                        text-align: center;
                        font-weight: bold;
                    }
                    .dep-table td {
                        border: 1px solid #000;
                        padding: 8px 5px;
                        vertical-align: middle;
                        color: #555;
                    }
                    .prepared-section {
                        margin-bottom: 16px;
                        color: #555;
                    }
                    .amount-in-words-section {
                        margin-bottom: 16px;
                        color: #555;
                        text-align: left;
                    }
                    .terms-section {
                        margin-bottom: 16px;
                        color: #555;
                    }
                    .terms-content {
                        font-size: 13px;
                        color: #555;
                        line-height: 1.6;
                        white-space: pre-wrap;
                    }
                    .text-caption {
                        font-size: 12px;
                        color: #666;
                    }
                    .signature-section {
                        margin-top: auto;
                        padding-top: 40px;
                    }
                    .pa-5 {
                        padding: 20px;
                    }
                    .mx-auto {
                        margin-left: auto;
                        margin-right: auto;
                    }
                    img {
                        max-width: 100%;
                        height: auto;
                    }
                    @page {
                        margin: 0;
                        size: A4 portrait;
                    }
                    @media print {
                        * {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                            background: white !important;
                            padding: 0;
                            margin: 0;
                        }
                        .report-paper {
                            min-height: 297mm;
                            margin: 0 auto !important;
                            padding: 20px !important;
                            box-shadow: none !important;
                            max-width: 280mm !important;
                            width: 100% !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        .dep-table th {
                            background-color: #f0f0f0 !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        .meta-item:not(.justify-end) {
                            justify-content: flex-start !important;
                            text-align: left !important;
                        }
                        .meta-label {
                            text-align: left !important;
                            padding-left: 0 !important;
                        }
                        .justify-end {
                            justify-content: flex-end !important;
                        }
                        .d-flex.justify-end {
                            display: flex !important;
                            justify-content: flex-end !important;
                        }
                        .d-print-none {
                            display: none !important;
                        }
                        .system-generated-footer {
                            display: block !important;
                            visibility: visible !important;
                            text-align: center;
                            margin-top: 20px;
                            padding-top: 10px;
                            font-size: 12px;
                            color: #666;
                            border-top: 1px solid #ddd;
                        }
                    }
                    .system-generated-footer {
                        text-align: center;
                        margin-top: 20px;
                        padding-top: 10px;
                        font-size: 12px;
                        color: #666;
                        border-top: 1px solid #ddd;
                    }
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
                </html>
            `);

            printWindow.document.close();

            // Wait for images to load before printing
            printWindow.onload = function () {
                const images = printWindow.document.getElementsByTagName('img');
                let imagesLoaded = 0;
                const totalImages = images.length;

                if (totalImages === 0) {
                    setTimeout(() => {
                        printWindow.moveTo(0, 0);
                        printWindow.focus();
                        printWindow.print();
                        printWindow.onafterprint = () => {
                            printWindow.close();
                        };
                    }, 500);
                } else {
                    Array.from(images).forEach((img) => {
                        if (img.complete) {
                            imagesLoaded++;
                        } else {
                            img.onload = () => {
                                imagesLoaded++;
                                if (imagesLoaded === totalImages) {
                                    setTimeout(() => {
                                        printWindow.moveTo(0, 0);
                                        printWindow.focus();
                                        printWindow.print();
                                        printWindow.onafterprint = () => {
                                            printWindow.close();
                                        };
                                    }, 500);
                                }
                            };
                            img.onerror = () => {
                                imagesLoaded++;
                                if (imagesLoaded === totalImages) {
                                    setTimeout(() => {
                                        printWindow.moveTo(0, 0);
                                        printWindow.focus();
                                        printWindow.print();
                                        printWindow.onafterprint = () => {
                                            printWindow.close();
                                        };
                                    }, 500);
                                }
                            };
                        }
                    });

                    if (imagesLoaded === totalImages) {
                        setTimeout(() => {
                            printWindow.moveTo(0, 0);
                            printWindow.focus();
                            printWindow.print();
                            printWindow.onafterprint = () => {
                                printWindow.close();
                            };
                        }, 500);
                    }
                }
            };
        }
    },
};
</script>

<style scoped>
.header-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.company-info {
    flex: 1;
}

.company-name {
    color: #333;
    font-size: 20px;
    letter-spacing: 0.5px;
}

.company-text {
    font-size: 14px;
    color: #555;
    margin: 2px 0;
    display: flex;
    align-items: center;
}

.logo-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.logo-img {
    max-height: 70px;
    max-width: 150px;
}

.report-title {
    color: #333;
    font-size: 20px;
}

.lines {
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 16px;
}

.full-height {
    min-height: 100vh;
}

.grey-lighten-3 {
    background-color: #eeeeee !important;
}

.report-paper {
    background-color: white;
    color: black;
    font-family: 'Times New Roman', serif;
    max-width: 280mm;
    width: 100%;
    min-height: 297mm;
}

/* .meta-info-box {
    border: 1px solid #000;
} */

.meta-item {
    height: 35px;
}

.meta-label {
    font-weight: 500;
    color: black;
}

.meta-value {
    color: black;
}

.dep-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.dep-table th {
    background-color: #f0f0f0;
    border: 1px solid #000;
    padding: 8px 5px;
    color: #333;
}

.dep-table td {
    border: 1px solid #000;
    padding: 8px 5px;
    vertical-align: middle;
    color: #555;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.amount-in-words-section {
    margin-bottom: 16px;
    color: #555;
    text-align: left;
}

.terms-section {
    margin-bottom: 16px;
    color: #555;
}

.terms-content {
    font-size: 13px;
    color: #555;
    line-height: 1.6;
    white-space: pre-wrap;
}

.gap-2 {
    gap: 8px;
}

/* Print Styles */
@media print {

    .v-application,
    .v-main,
    body {
        background: white !important;
    }

    body>*:not(.v-application) {
        display: none !important;
    }

    .v-application>*:not(.v-application__wrap) {
        display: none !important;
    }

    .v-application__wrap>*:not(main) {
        display: none !important;
    }

    main * {
        visibility: hidden;
    }

    #printable-area,
    #printable-area * {
        visibility: visible;
    }

    #printable-area {
        position: relative !important;
        box-shadow: none !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .page-header {
        margin-bottom: 20px;
    }

    .page-content {
        display: block;
    }

    .signature-section {
        margin-top: auto;
        padding-top: 40px;
    }

    .report-paper {
        box-shadow: none !important;
        max-width: 280mm !important;
        width: 100% !important;
        margin: 0 auto !important;
        padding: 20px !important;
        background-color: white !important;
        color: black !important;
        font-family: 'Times New Roman', serif !important;
        display: block !important;
        position: relative !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .meta-info-box {
        border: none !important;
    }

    .meta-item {
        height: auto !important;
    }

    .meta-item:not(.justify-end) {
        justify-content: flex-start !important;
        text-align: left !important;
    }

    .meta-label {
        text-align: left !important;
    }

    .justify-end {
        justify-content: flex-end !important;
    }

    .d-flex.justify-end {
        display: flex !important;
        justify-content: flex-end !important;
    }

    .dep-table th {
        background-color: #f0f0f0 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .dep-table td,
    .dep-table th {
        border: 1px solid #000 !important;
    }

    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .d-print-none {
        display: none !important;
    }

    .system-generated-footer {
        display: block !important;
        visibility: visible !important;
        text-align: center;
        margin-top: 20px;
        padding-top: 10px;
        font-size: 12px;
        color: #666;
        border-top: 1px solid #ddd;
    }
}
</style>